import EntryPoints from './EntryPoints';

export default EntryPoints;
